<!--
================================================
Un composant pour changer de thème en un clic depuis AppNavbarComp

Url d'accès : http://localhost:8080/fr/cronocoud-inc/timeTracking
@todo écrire test por le comp
@todo faire une tooltip comme github pour dire d'aller dans les settings
@todo Ne va pas car des changement de page le theme est perdu !
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <span id="ThemeSwitchComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
<!--        {{'Hello ! :) I am ' + $options.name}}-->

      <span class="cont" v-bind:title="(themeToDisplay=='dark') ? $t('afficherLeThemeLumineux') : $t('afficherLeThemeSombre')">
        <font-awesome-icon v-on:click="toggleTheme()" class="icon darkOff" v-if="themeToDisplay=='dark'" :icon="['fas', 'sun']"  />
        <font-awesome-icon v-on:click="toggleTheme()" class="icon darkOn" v-else-if="themeToDisplay=='light'" :icon="['fas', 'moon']" />
      </span>

    </span>

<!--    https://www.npmjs.com/package/v-click-outside-->
<!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";
    // import _ from 'lodash'

    // import vClickOutside from 'v-click-outside'

    export default {
        name: 'ThemeSwitchComp', //utile dans vue dev tool
        mixins: [
            GlobalErrorNotification,
            SentryMixin,
            InterceptorMixin,
            TrackingMixin
        ],
        // components: {},

        // directives: {

        //     clickOutside: vClickOutside.directive, // en event mouseleave peut-être une alternative !

        //     /**
        //      * Permet de focuser un élément avec v-focus (requiert l'attribut "tabindex" sur la cible)
        //      * @link https://vuejs.org/v2/guide/custom-directive.html
        //      **/
        //     focus: {
        //         update: function (el) {
        //             el.focus()
        //         }
        //     }
        // },

        // props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            // placeholder : String, // attribut placeholder du champ
        // },
        data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug // (ou dispo dans this.$auth.getUserSlug())
                // componentIsReady : false, // indique quand le composant est prêt à être affiché
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                themeToDisplay: state => state.app.themeToDisplay
          }),

            //----------------------------------------------

            // vuex 2-way data binding forms https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
            // email: {
            //     get () {return this.$store.state.user.email},
            //     set (value) {this.$store.commit('UpdateUserEmail', value)}
            // },

            //----------------------------------------------

            // other computed props :
            // compProp: {
            //     get: function () {return this.foo},
            //     set: function (newValue) {this.foo = newValue}
            // }

        },
        // watch: {
        //     // à chaque fois que la prop computed change, cette fonction s'exécutera
        //     user: function () {
        //     }
        // },

        // filters: {
        //     capitalize: function (value) {
        //         if (!value) return ''
        //         value = value.toString()
        //         return value.charAt(0).toUpperCase() + value.slice(1)
        //     },

        methods: {
            toggleTheme: function(){
              if(this.themeToDisplay=='light'){
                this.$store.commit('UpdateThemeToDisplay', 'dark')
                this.saveThemeInUser('dark')
              }
              else{
                this.$store.commit('UpdateThemeToDisplay', 'light')
                this.saveThemeInUser('light')
              }
            },

          /**
           Sauvegarde le thème préféré dans le compte de l'utilisateur
           Copié sur UserSettingThemeComp.sendFormQuery()
           @params theme | string (light|dark)
           **/
          saveThemeInUser(theme) {

            let self = this;
            return self.$http
                .patch(`organizations/${self.organizationSlug}/users/${self.userSlug}`, {
                      preferedTheme: theme
                    },
                    {headers: {Authorization: self.$auth.header()}}
                )
                .then(function (response) {
                  self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                  self.$store.commit('UpdateUserPreferedTheme', theme)

                  if (response.status == 200) {

                    // création du cookie qui servira pour les cas ou l'utilisateur n'est pas authentifié
                    self.$cookie.set('preferedTheme', theme, {expires: 365})

                    let trackingDetail= 'Prefered theme modified'
                    self.ga4GlobalEventTrack(trackingDetail , {value:theme})

                    self.$mixpanel.track(trackingDetail, {"theme":theme});
                  }
                })
                .catch(function (error) {
                  // On catch ici sauf ce qui relève des intercepteurs Axios
                  if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                    self.logToSentry(self, error, 'error')
                    let errorCode = '0049 B' ; let errorDetail = 'error in modify theme query'
                    self.showGlobalErrorNotif(self, errorCode)
                    self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": errorDetail})
                    self.$sentry.captureMessage(`Error ${errorCode} > ${errorDetail} : ${error}`, 'error')
                  }
                }).then(() => {
                  // toujours exécuté
                  self.isSubmiting = false;
                })

          },

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')


            //  pour écouter un event ($on peut être remplacé par $once pour une seule écoute)
            // this.$root.$on('demo_event', (foo) => {
            //
            // })

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #ThemeSwitchComp{
      margin: .8rem  auto 0 .4rem;
      vertical-align:baseline;
      display: inline-block;
      position: relative;
      bottom: -0.3rem;
      .icon{
        cursor: pointer;
        font-size: 1.2rem;
        //transition: left 200ms ease;
        &.darkOn{
          //color:red !important;
          //position: relative; left: -1rem;
        }
        &.darkOff{
          //color:red !important;
          //position: relative; right: -1rem;
        }
      }


      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////
      .icon{
        color:#ccc;
        &:hover{
          color:$darkLightBlue
        }
        transition: color 300ms ease-out;
      }
      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        .icon{
          color:lighten($darkBg,12%);
          &:hover{
            color:$brandYellow !important;
          }
        }

      }

    }
</style>
